import {completeUpload} from './mutations'

export default async function (client, fileId) {
  await client.mutate({
    mutation: completeUpload,
    variables: {
      fileId
    }
  })
}
